import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Heading, Link, List, ListItem, Text } from '@chakra-ui/react';

import { getTimeSince } from 'app/project-reviews/helpers';
import { Submission } from 'app/types/reviews';

type RelatedSubmissionsListProps = {
  submissions: Submission[];
  currReviewerId: number | null;
};

export const RelatedSubmissionsList: React.FC<RelatedSubmissionsListProps> = ({ submissions, currReviewerId }) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading size="h3" as="h3" mb={2}>
        {t('projectReviews.history.relatedProjectsReviews')}
      </Heading>
      <List spacing={2} mb={6}>
        {submissions.map((s) => (
          <ListItem key={s.id}>
            <Link
              as={ReactRouterLink}
              to={`/project-reviews/${s.id}/feedback`}
              color="blue.500"
              textDecoration="underline"
              target="_blank"
            >
              {s.projectTitle ?? ''} -{' '}
              {s.graderId === currReviewerId
                ? t('projectReviews.history.reviewNumberYours', { index: 1, submissionId: s.id })
                : t('projectReviews.history.reviewNumber', { index: 1, submissionId: s.id })}
            </Link>
            {(s.result || s.completedAt) && (
              <Text size="caption" ml={0} mt={1}>
                {[s.result, s.completedAt ? getTimeSince(s.completedAt) : null].filter(Boolean).join(' • ')}
              </Text>
            )}
          </ListItem>
        ))}
      </List>
    </>
  );
};
